function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect } from "react-native-svg";

function SvgMiniUltraband(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 302,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Rect, {
    x: 1,
    y: 1.5,
    width: 300,
    height: 86.25,
    rx: 43.125,
    fill: "#D9D9D9",
    stroke: props.fill,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 27.25,
    y: 27.75,
    width: 247.5,
    height: 33.75,
    rx: 16.875,
    fill: props.fill,
    stroke: props.fill,
    strokeWidth: 3
  }));
}

export default SvgMiniUltraband;